<div
  class="d-flex justify-content-between flex-wrap align-items-center mb-2 mb-lg-4"
>
  <h3 class="m-0">
    {{ 'pages.cybersocxdr.last24h.last24HoursInformations' | translate }}
  </h3>
  <a class="link-chevron" routerLink="/xtended-soc/incidents">{{
    'pages.cybersocxdr.last24h.viewAllIncidents' | translate
  }}</a>
</div>
<div class="row">
  <div class="d-flex gap-3">
    <div class="fw-bold">
      <span class="badge rounded-pill fs-5 text-bg-primary">{{
        last24HData?.criticalIncidents ?? ''
      }}</span>
      {{ 'pages.cybersocxdr.last24h.criticalIncidents' | translate }}
    </div>
    <div class="fw-bold">
      <span class="badge rounded-pill fs-5 text-bg-primary">{{
        last24HData?.newIncidents ?? ''
      }}</span>
      {{ 'pages.cybersocxdr.last24h.newIncidents' | translate }}
    </div>
  </div>
</div>
